
// @ts-nocheck
import locale_nl_46json_a41a5c2e from "#nuxt-i18n/a41a5c2e";
import locale_en_46json_bd7b47c2 from "#nuxt-i18n/bd7b47c2";

export const localeCodes =  [
  "nl",
  "en"
]

export const localeLoaders = {
  nl: [
    {
      key: "locale_nl_46json_a41a5c2e",
      load: () => Promise.resolve(locale_nl_46json_a41a5c2e),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_bd7b47c2",
      load: () => Promise.resolve(locale_en_46json_bd7b47c2),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "nl",
      language: "nl-NL",
      name: "Nederlands",
      isCraftDefault: true,
      craftSiteId: 1,
      _hreflang: "nl-NL",
      _sitemap: "nl-NL",
      files: [
        {
          path: "/vercel/path0/src/i18n/locales/nl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      language: "en-150",
      name: "English",
      craftSiteId: 2,
      _hreflang: "en-150",
      _sitemap: "en-150",
      files: [
        {
          path: "/vercel/path0/src/i18n/locales/en.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "nl",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_and_default",
  lazy: false,
  langDir: "../src/i18n/locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "config",
  pages: {
    "news-slug": {
      nl: "/nieuws/[slug]",
      en: "/news/[slug]"
    },
    "locations-slug": {
      nl: "/locaties/[slug]",
      en: "/locations/[slug]"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "nl",
    language: "nl-NL",
    name: "Nederlands",
    isCraftDefault: true,
    craftSiteId: 1,
    _hreflang: "nl-NL",
    _sitemap: "nl-NL",
    files: [
      {
        path: "/vercel/path0/src/i18n/locales/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    language: "en-150",
    name: "English",
    craftSiteId: 2,
    _hreflang: "en-150",
    _sitemap: "en-150",
    files: [
      {
        path: "/vercel/path0/src/i18n/locales/en.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/